export default {
    title: 'Create search agent',
    step1: {
        title: 'Name the search agent',
        error: 'Please enter a title for the search agent',
        label: 'Name'
    },
    step2: {
        title: 'Choose a work space for the search agent'
    },
    step3: {
        title: 'Or: Create a new work space',
        label: 'Work space title',
        error: 'Please choose or create a work space'
    },
    submit: 'Create search agent',
    success: 'The search agent <strong>"{title}"</strong> was successfully added to the work space.',
    error: 'An error occurred: <strong>"{title}"</strong>.'
}
